<i18n
  src="@/locales/views/customer/quality_control/destination/list_containers.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>

<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    name="customer_quality_control_destination_list_agro_exporters_path"
    :params="{
      customer_id: customer_id
    }"
  ></go-back-link>

  <bread-crumbs :labels="[module_name, agro_exporter?.name]"></bread-crumbs>

  <template v-if="load_data_general">
    <h1 class="page-title">
      <i class="fa-solid fa-container-storage"></i
      ><span class="space-icon"></span>
      {{ $t("labels.title") }}
    </h1>

    <div class="mt-8 flex flex-row">
      <div class="panel-plain-label">
        <badge-default
          :label="
            containers.length + ' ' + $t('labels.total_number_containers')
          "
        />
        <span class="space-actions"></span>
        <badge-default
          :label="
            total_inspections + ' ' + $t('labels.total_number_inspections')
          "
        />
      </div>
    </div>

    <div class="mt-8 flex flex-col">
      <div class="table-first-container">
        <div class="table-second-container">
          <div class="table-third-container">
            <table class="table">
              <thead class="table-header">
                <tr>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.week") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.container_code") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.load_date") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.crop") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.packing_house") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.total_inspections") }}
                  </th>
                  <th scope="col" class="table-header-cell"></th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr
                  class="table-row"
                  v-for="container in containers"
                  :key="container.id"
                >
                  <td class="table-cell">
                    {{ container.week }}
                  </td>
                  <td class="table-cell-main">
                    {{ container.container_code }}
                  </td>
                  <td class="table-cell">
                    {{ dateFormatter(container.load_date) }}
                  </td>
                  <td class="table-cell">
                    {{ container.crop?.name }}
                  </td>
                  <td class="table-cell">
                    {{ container.packing_house_names.join(", ") }}
                  </td>
                  <td class="table-cell">
                    {{ container.total_inspections }}
                  </td>
                  <td class="table-cell-action">
                    <button class="link" @click="goToListTemplates(container)">
                      <i class="fa-solid fa-pen"></i
                      ><span class="space-icon"></span>
                      {{ $t("labels.manage_link") }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </template>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/customer/requesters/quality_control/container/list_containers.js";
export default {
  name: "ListContainers",

  props: ["customer_id", "agro_exporter_id"],
  data() {
    return {
      load_data_general: false,
      agro_exporter: {},
      containers: []
    };
  },
  computed: {
    total_inspections: function () {
      return this.containers.reduce(
        (sum, value) => sum + value.total_inspections,
        0
      );
    }
  },
  methods: {
    fetchAgroExporter: async function () {
      let response = await Requester.fetchAgroExporter({
        agro_exporter_id: this.agro_exporter_id,
        customer_id: this.customer_id
      });
      this.agro_exporter = response.data;
    },
    fetchContainers: async function () {
      let response = await Requester.fetchContainers({
        agro_exporter_id: this.agro_exporter_id,
        customer_id: this.customer_id
      });
      this.containers = response.data;
      this.load_data_general = true;
    },
    goToListTemplates: function (container) {
      this.$router.push({
        name: "customer_quality_control_destination_list_templates_path",
        params: {
          agro_exporter_id: this.agro_exporter_id,
          container_id: container.id
        }
      });
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          customer_id: this.customer_id
        }
      }).then(() => {
        this.fetchAgroExporter();
        this.fetchContainers();
      })
    );
  }
};
</script>
